import {DependencyList, useEffect, useState} from 'react';

type Fn = () => void;
type HistoryBackOptions = {fn: Fn};

function useHistoryBackAOS(fn: Fn, deps?: DependencyList): void;
/** 객체로 선언할 경우 state 값을 변경하여 사용하는 컴포넌트를 리렌더링시킨다. */
function useHistoryBackAOS(options: HistoryBackOptions, deps?: DependencyList): {isBindedHistoryBack: boolean};

function useHistoryBackAOS(fnOrOptions: Fn | HistoryBackOptions, deps: DependencyList = []) {
  const isOptions = typeof fnOrOptions === 'object';
  const [isBindedHistoryBack, setIsBindedHistoryBack] = useState(false);

  const fn = isOptions ? fnOrOptions.fn : fnOrOptions;

  useEffect(() => {
    const recalling = window.historyBack;

    window.historyBack = () => {
      fn();
      /** true를 넘기는 경우 안드로이드 네이티브 back키 동작하지 않음 */
      return true;
    };

    if (isOptions) {
      setIsBindedHistoryBack(true);
    }

    return () => {
      window.historyBack = recalling;

      if (isOptions) {
        setIsBindedHistoryBack(false);
      }
    };
  }, deps);

  if (isOptions) {
    return {isBindedHistoryBack};
  }
}

export default useHistoryBackAOS;
